module.exports = __webpack_public_path__ + "img/ctm_pic_1.e8d36a74.jpg";